import { makeStyles } from '@mui/styles';

export default makeStyles(theme => ({
    appbar: {
        paddingTop: `var(--safe-area-inset-top)`,
        //paddingBottom: `var(--safe-area-inset-bottom)`,
        paddingLeft: `var(--safe-area-inset-left)`,
        paddingRight: `var(--safe-area-inset-right)`,
    },

    paper: {
        paddingTop: `var(--safe-area-inset-top)`,
        paddingBottom: `var(--safe-area-inset-bottom)`,
        paddingLeft: `var(--safe-area-inset-left)`,
        paddingRight: `var(--safe-area-inset-right)`,
    }
}))